import { NOTIFICATION_ADD, NOTIFICATION_REMOVE } from 'constants/actiontypes';

const INITIAL_STATE = [];

const maxNotifications = 10;

let notificationId = 1;

export const getNewNotifId = () => notificationId++;

export default (state=INITIAL_STATE, action) => {
	switch(action.type) {
		case NOTIFICATION_ADD:
			return [
				...state,
				{
					id: action.id,
					data: action.data,
					type: action.notifType || 'primary',
				}
			];
		case NOTIFICATION_REMOVE:
			return state.filter((notif, index) => {
				return (notif.id !== action.id);
			});
		default: return state;
	}
};



/** WEBPACK FOOTER **
 ** ./reducers/notification.js
 **/